export default __webpack_public_path__ + "static/media/avatar_110.f6d61a7f.png";